"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const TabPanel = _tpmProductIntl.Tab.TabPanel;
const formatAdvantageCommon = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$tabs = _ref.tabs,
    tabs = _ref$tabs === void 0 ? [] : _ref$tabs,
    _ref$resetText = _ref.resetText,
    resetText = _ref$resetText === void 0 ? '' : _ref$resetText,
    _ref$sureText = _ref.sureText,
    sureText = _ref$sureText === void 0 ? '' : _ref$sureText;
  const handledItemsList = tabs === null || tabs === void 0 ? void 0 : tabs.map((activityItem, index) => {
    const _ref2 = activityItem || {},
      data = _ref2.data,
      _ref2$tip = _ref2.tip,
      tip = _ref2$tip === void 0 ? '' : _ref2$tip,
      _ref2$text = _ref2.text,
      text = _ref2$text === void 0 ? '' : _ref2$text;
    let tableConfig = {
      columns: [],
      records: []
    };
    try {
      tableConfig = JSON.parse(data);
    } catch (error) {}
    return _objectSpread(_objectSpread({
      text
    }, tableConfig), {}, {
      id: `id${index + 1}`,
      tip: tip ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
        html: tip
      }) : ''
    });
  });
  return {
    porintId,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    bg,
    tabs: handledItemsList,
    resetText,
    sureText
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatAdvantageCommo = formatAdvantageCommon(data, {
        domains
      }),
      porintId = _formatAdvantageCommo.porintId,
      title = _formatAdvantageCommo.title,
      bg = _formatAdvantageCommo.bg,
      _formatAdvantageCommo2 = _formatAdvantageCommo.tabs,
      tabs = _formatAdvantageCommo2 === void 0 ? [] : _formatAdvantageCommo2,
      resetText = _formatAdvantageCommo.resetText,
      sureText = _formatAdvantageCommo.sureText;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: "gems-materials-qci__newUI-table"
    }, (0, _reportUtil.reportShow)(['show_newUI_Table', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      bg: bg,
      title: title
    }, (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 0 && /*#__PURE__*/React.createElement(_tpmProductIntl.Tab, {
      itemList: tabs
    }, tabs.map((item, index) => /*#__PURE__*/React.createElement(TabPanel, {
      id: item.id,
      key: index
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Table, Object.assign({}, item, {
      resetText: resetText,
      sureText: sureText
    })))))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}